module.exports = __webpack_public_path__ + "img/编组 9.83f571bf.png";